export const ConfigMixin = {
  data() {
    return {
      LIMIT_DEFAULT_SLICK_EVENT: 5,
      // TODO: fix here
      BOOMTV_DOMAIN: 'boom.tv',
      AVGL_DOMAIN: 'avgl.org',
      AVGL_VERSION: 'beta v.0.1.01',
      QUEUE_UP_VERSION: 'beta v 0.1.0',
      QUEUE_UP_SOLOGAN: 'Pay to game with your favorite players!',
    };
  },
};
